import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-methods" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_paid" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_your-card" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_paypal" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_invoices" }, null, -1)
const _hoisted_6 = { class: "e-application-wrapper__card-footer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          class: _normalizeClass(["defaultButton whiteBG", {
          'defaultButton--active': _ctx.selectedItem === 'tax-confirmation',
        }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectItem('tax-confirmation')))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.payment_methods.already_paid_administrative_fee_title`)), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`forms.payment_methods.pay_administration_fee_now_title`)), 1),
        _createElementVNode("text", null, _toDisplayString(_ctx.$t(`forms.payment_methods.description2`)), 1),
        (_ctx.cardPaymentEnabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: _normalizeClass(["defaultButton whiteBG", { 'defaultButton--active': _ctx.selectedItem === 'credit-card' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectItem('credit-card')))
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.payment_methods.credit_card`)), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.cardPaymentEnabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: _normalizeClass(["defaultButton whiteBG", { 'defaultButton--active': _ctx.selectedItem === 'paypal' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectItem('paypal')))
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.payment_methods.paypal`)), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: _normalizeClass(["defaultButton whiteBG", { 'defaultButton--active': _ctx.selectedItem === 'upn' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectItem('upn')))
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.payment_methods.upn`)), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        class: "defaultButton",
        disabled: !_ctx.isValid,
        onClick: _ctx.finishApplication
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(_ctx.selectedItem === "tax-confirmation"
          ? _ctx.$t("forms.payment_methods.button_label")
          : _ctx.$t("forms.new_form.next")), 1),
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createElementVNode("div", {
        class: "back-button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('prevPage')))
      }, _toDisplayString(_ctx.$t("global.back")), 1),
      _createVNode(_component_router_link, { to: { name: 'NewApplications' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}